import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faArrowRight, faAt, faCalendarAlt, faDollarSign, faFilter, faHashtag, faSave, faTimes, faUsers } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        id_paciente: '',
        paciente_nuevo: '',
        paciente: [],
        pacientes: [],
        errors: [],
    }
    sessionExpired = () => {
        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = async (e) => {
        e.preventDefault();
        const { id_paciente, paciente_nuevo } = this.state;
        var errors = [];
        if (!id_paciente) { errors.push("error_id_paciente"); }
        if (!paciente_nuevo) { errors.push("error_paciente_nuevo"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var dataHistoriaClinica = {
            id_paciente: id_paciente,
            paciente_nuevo: paciente_nuevo,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const historiasClinicasDataRes = await authAxios.post("historias_clinicas/register", dataHistoriaClinica);
            if (!historiasClinicasDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Historias Clínicas!',
                historiasClinicasDataRes.data.msj,
                'success'
            );
            this.props.history.push("/UpHistoriasClinicas/" + historiasClinicasDataRes.data.ID_HISTORIA_CLINICA);
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    selectPaciente = (itemPacientes) => {
        Swal.showLoading();
        this.setState({
            id_paciente: itemPacientes.ID_PACIENTE,
            paciente: itemPacientes
        });
        Swal.close();
    }
    ListarPacientesHistoriasClinicas(page) {
        Swal.showLoading();
        let bname_paciente = document.getElementById('bname_paciente').value;
        let btype_paciente = document.getElementById('btype_paciente').value;
        if (bname_paciente == '') {
            bname_paciente = 0;
        }
        if (btype_paciente == '') {
            btype_paciente = 0;
        }
        authAxios.get("historias_clinicas/pacientes/" + btype_paciente + "/" + bname_paciente + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.status;
                if (!status) {
                    this.sessionExpired();
                }
                this.setState({
                    pacientes: dataResult.data.data,
                    page_pacientes: dataResult.data.total,
                    last_pacientes: dataResult.data.last_page,
                    current_pacientes: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarPacientesHistoriasClinicas(1)
    }
    render() {
        const {
            id_paciente,
            paciente_nuevo,
            paciente,
            pacientes,
            page_pacientes,
            last_pacientes,
            current_pacientes
        } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NUEVA HISTORIA CLÍNICA</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>I. DATOS PERSONALES</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="id_paciente">ID. Paciente</label>
                                                    <div className={((this.errorVerify("error_id_paciente")) ? "is-invalid" : "") + " btn-group"} role="group" aria-label="">
                                                        <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#PacientesModal" slot='end'>
                                                            <FontAwesomeIcon icon={faUsers} />
                                                        </button>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="id_paciente" id="id_paciente" value={id_paciente} 
                                                            className={((this.errorVerify("error_id_paciente")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="ID. Paciente" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione un Paciente</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="paciente_nuevo">Paciente Nuevo</label>
                                                    <select name="paciente_nuevo"
                                                        id="paciente_nuevo"
                                                        className={((this.errorVerify("error_paciente_nuevo")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">Seleccione una Opción</option>
                                                        <option value="0">NO</option>
                                                        <option value="1">SI</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione una Opción</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="tipo_identificacion_paciente">T. Identificación</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="tipo_identificacion_paciente" id="tipo_identificacion_paciente"
                                                        value={
                                                            (() => {
                                                                switch (paciente.TIPO_IDENTIFICACION) {
                                                                    case '1':
                                                                        return('C.C.')
                                                                    case '2':
                                                                        return('C.E.')
                                                                    case '3':
                                                                        return('R.C.')
                                                                    case '4':
                                                                        return('T.I.')
                                                                    case '5':
                                                                        return('RUT')
                                                                    default:
                                                                        break;
                                                                }
                                                            })()
                                                        }
                                                        className="form-control form-control-sm" placeholder="T. Identificación" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="identificacion_paciente">Identificación</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="identificacion_paciente" id="identificacion_paciente" value={paciente.IDENTIFICACION}
                                                            className="form-control form-control-sm" placeholder="Identificación" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="nombre_paciente">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre_paciente" id="nombre_paciente" value={paciente.NOMBRE}
                                                        className="form-control form-control-sm" placeholder="Nombre" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="sexo_paciente">Sexo</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="sexo_paciente" id="sexo_paciente"
                                                        value={
                                                            (() => {
                                                                switch (paciente.SEXO) {
                                                                    case '1':
                                                                        return('FEMENINO')
                                                                    case '2':
                                                                        return('MASCULINO')
                                                                    case '3':
                                                                        return('OTRO')
                                                                    default:
                                                                        break;
                                                                }
                                                            })()
                                                        }
                                                        className="form-control form-control-sm" placeholder="Sexo" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="fecha_nacimiento_paciente">Fecha Nacimiento</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="fecha_nacimiento_paciente" id="fecha_nacimiento_paciente" value={paciente.FECHA_NACIMIENTO}
                                                            className="form-control form-control-sm" placeholder="Fecha Nacimiento" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="edad_paciente">Edad</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="edad_paciente" id="edad_paciente" value={paciente.EDAD}
                                                            className="form-control form-control-sm" placeholder="Edad" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="ocupacion_paciente">Ocupación</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="ocupacion_paciente" id="ocupacion_paciente" value={paciente.OCUPACION}
                                                        className="form-control form-control-sm" placeholder="Ocupación" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-4'>
                                                    <label htmlFor="direccion_paciente">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion_paciente" id="direccion_paciente" value={paciente.DIRECCION}
                                                        className="form-control form-control-sm" placeholder="Dirección" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="barrio_paciente">Barrio</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="barrio_paciente" id="barrio_paciente" value={paciente.BARRIO}
                                                        className="form-control form-control-sm" placeholder="Barrio" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="correo_electronico_paciente">Correo Electrónico</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faAt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="correo_electronico_paciente" id="correo_electronico_paciente" value={paciente.EMAIL}
                                                            className="form-control form-control-sm" placeholder="Correo Electrónico" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="celular_paciente">Celular</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="celular_paciente" id="celular_paciente" value={paciente.CELULAR}
                                                            className="form-control form-control-sm" placeholder="Celular" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>I. DATOS PERSONALES - INFORMACIÓN DEL ACUDIENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-4'>
                                                    <label htmlFor="nombre_acudiente">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre_acudiente" id="nombre_acudiente" value={paciente.NOMBRE_ACUDIENTE}
                                                        className="form-control form-control-sm" placeholder="Nombre" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="parentesco">Parentesco</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="parentesco" id="parentesco" value={paciente.PARENTESCO}
                                                        className="form-control form-control-sm" placeholder="Parentesco" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-4'>
                                                    <label htmlFor="ocupacion_acudiente">Ocupación</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="ocupacion_acudiente" id="ocupacion_acudiente" value={paciente.OCUPACION_ACUDIENTE}
                                                        className="form-control form-control-sm" placeholder="Ocupación" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="direccion_acudiente">Dirección</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="direccion_acudiente" id="direccion_acudiente" value={paciente.DIRECCION_ACUDIENTE}
                                                        className="form-control form-control-sm" placeholder="Dirección" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="celular_acudiente">Celular</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="celular_acudiente" id="celular_acudiente" value={paciente.CELULAR_ACUDIENTE}
                                                            className="form-control form-control-sm" placeholder="Celular" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Guardar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterHistoriasClinicas"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PacientesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PacientesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PacientesModalLabel">Pacientes</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-4">
                                        <select name="btype_paciente" id="btype_paciente"
                                            className={"form-select form-select-sm"}>
                                            <option value="">-</option>
                                            <option value="1">PACIENTE</option>
                                            <option value="2">IDENTIFICACIÓN</option>
                                        </select>
                                    </div>
                                    <div className="col-xl-6">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bname_paciente" name="bname_paciente" placeholder="Buscar Paciente" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarPacientesHistoriasClinicas(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                </div>
                                <br />
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">PACIENTE</th>
                                                    <th className="align-middle">IDENTIFICACIÓN</th>
                                                    <th className="align-middle">CELULAR</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pacientes.map((itemPacientes) => (
                                                        <tr key={itemPacientes.ID_PACIENTE}>
                                                            <td>{itemPacientes.NOMBRE}</td>
                                                            <td>{itemPacientes.IDENTIFICACION}</td>
                                                            <td>{itemPacientes.CELULAR}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectPaciente(itemPacientes)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <nav aria-label="Page navigation example">
                                    <ul style={{ marginBottom: 0 }} className="pagination">
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientesHistoriasClinicas(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientesHistoriasClinicas(current_pacientes - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                        {(() => {
                                            let p = [];
                                            p.push(<li className="page-item" key={current_pacientes}><a className="page-link" href="#" onClick={() => this.ListarPacientesHistoriasClinicas(current_pacientes)}>{current_pacientes}</a></li>);
                                            return p;
                                        })()}
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientesHistoriasClinicas(current_pacientes + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientesHistoriasClinicas(last_pacientes)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                    </ul>
                                </nav>
                            </div>
                            <div style={{ justifyContent: 'left' }} class="modal-footer text-muted">
                                <b>Page</b> <span className="badge bg-primary">{current_pacientes}</span> <b>of</b> <span className="badge bg-primary">{last_pacientes}</span> | <b>Records</b> <span className="badge bg-success">{page_pacientes}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;